export const education = {
  en: {
    title: 'Education',
    items: [
      {
        degree: 'Bachelor in Computer Science',
        institution: 'Federal University of Sergipe (UFS)',
        date: 'In progress'
      },
      {
        degree: 'Bachelor of Laws',
        institution: 'Tiradentes University',
        date: '2010 - 2014'
      },
      {
        degree: 'MBA in Real Estate Law',
        institution: 'Cândido Mendes University',
        date: '2017'
      }
    ]
  },
  pt: {
    title: 'Formação Acadêmica',
    items: [
      {
        degree: 'Bacharelado em Ciência da Computação',
        institution: 'Universidade Federal de Sergipe (UFS)',
        date: 'Em andamento'
      },
      {
        degree: 'Bacharelado em Direito',
        institution: 'Universidade Tiradentes',
        date: '2010 - 2014'
      },
      {
        degree: 'MBA em Direito Imobiliário',
        institution: 'Universidade Cândido Mendes',
        date: '2017'
      }
    ]
  }
};